export interface Medida {
  id: string;
  date: string;
  weight?: string | null;
  leanMass?: number | null;
  muscleMass?: number | null;
  absoluteFat?: number | null;
}

// `weight` e String no schema ("59.0"). parseFloat aceitaria "59kg" e devolveria
// 59, mas tambem aceitaria lixo com numero no comeco; a validacao explicita
// evita exibir peso inventado.
export const pesoNumerico = (valor?: string | null): number | null => {
  const limpo = valor?.trim().replace(',', '.');
  if (!limpo || !/^-?\d+(\.\d+)?$/.test(limpo)) return null;

  const numero = Number.parseFloat(limpo);

  return Number.isFinite(numero) ? numero : null;
};

export const formatarPeso = (valor?: string | null): string => {
  const numero = pesoNumerico(valor);

  return numero === null ? '' : `${numero.toLocaleString('pt-BR', {minimumFractionDigits: 1, maximumFractionDigits: 1})} kg`;
};

// A API devolve as medidas em ordem decrescente de data, entao a anterior de
// um item e a proxima da lista.
export const variacaoDePeso = (atual: Medida, anterior?: Medida): number | null => {
  const a = pesoNumerico(atual.weight);
  const b = anterior ? pesoNumerico(anterior.weight) : null;

  if (a === null || b === null) return null;

  // Diferencas de arredondamento em float geram "0.0" com sinal; arredondar
  // em uma casa evita exibir variacao que nao existe.
  const diferenca = Math.round((a - b) * 10) / 10;

  return diferenca === 0 ? null : diferenca;
};

export const formatarVariacao = (diferenca: number | null): string => {
  if (diferenca === null) return '';

  const sinal = diferenca > 0 ? '+' : '−';

  return `${sinal}${Math.abs(diferenca).toLocaleString('pt-BR', {minimumFractionDigits: 1, maximumFractionDigits: 1})} kg`;
};

// date vem como 'YYYY-MM-DD'; montar com new Date recuaria um dia no fuso do
// Brasil, entao a data e formatada pelos pedacos da string.
export const formatarData = (valor?: string | null): string => {
  const partes = valor?.trim().slice(0, 10).split('-');
  if (!partes || partes.length !== 3) return '';

  const [ano, mes, dia] = partes;
  if (!/^\d{4}$/.test(ano) || !/^\d{2}$/.test(mes) || !/^\d{2}$/.test(dia)) return '';

  return `${dia}/${mes}/${ano}`;
};

export const composicao = (medida: Medida): {label: string; valor: string}[] =>
  [
    {label: 'Massa magra', valor: medida.leanMass},
    {label: 'Massa muscular', valor: medida.muscleMass},
    {label: 'Gordura', valor: medida.absoluteFat},
  ]
    .filter((item): item is {label: string; valor: number} => typeof item.valor === 'number')
    .map((item) => ({
      label: item.label,
      valor: `${item.valor.toLocaleString('pt-BR', {maximumFractionDigits: 1})} kg`,
    }));
